import React from 'react';
import { motion } from 'framer-motion';
import './MasterclassHero.css';
import heroPerson from '../assets/sir.png'; // Please copy your image to this path!

const MasterclassHero = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.2 },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: [0.25, 0.1, 0.25, 1.0] } },
  };

  const popVariants = {
    hidden: { opacity: 0, scale: 0.8 },
    visible: { opacity: 1, scale: 1, transition: { type: "spring", stiffness: 100, damping: 20, delay: 0.4 } },
  };

  return (
    <section className="mc-section mc-hero" id="home">
      {/* Floating AI Icons */}
      <div className="mc-ai-icons-container mc-hidden-mobile">
        {/* Sparkles / AI Generate */}
        <div className="mc-float-icon mc-icon-1">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 3v3"></path><path d="M18.5 5.5l-2 2"></path><path d="M21 12h-3"></path><path d="M18.5 18.5l-2-2"></path><path d="M12 21v-3"></path><path d="M5.5 18.5l2-2"></path><path d="M3 12h3"></path><path d="M5.5 5.5l2 2"></path></svg>
        </div>
        {/* Brain / Analytics */}
        <div className="mc-float-icon mc-icon-2">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9.5 2A2.5 2.5 0 0 1 12 4.5v15a2.5 2.5 0 0 1-4.96.44 2.5 2.5 0 0 1-2.96-3.08 3 3 0 0 1-.34-5.58 2.5 2.5 0 0 1 1.32-4.24 2.5 2.5 0 0 1 1.98-3A2.5 2.5 0 0 1 9.5 2Z"></path><path d="M14.5 2A2.5 2.5 0 0 0 12 4.5v15a2.5 2.5 0 0 0 4.96.44 2.5 2.5 0 0 0 2.96-3.08 3 3 0 0 0 .34-5.58 2.5 2.5 0 0 0-1.32-4.24 2.5 2.5 0 0 0-1.98-3A2.5 2.5 0 0 0 14.5 2Z"></path></svg>
        </div>
        {/* Code / Programming */}
        <div className="mc-float-icon mc-icon-3">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="16 18 22 12 16 6"></polyline><polyline points="8 6 2 12 8 18"></polyline></svg>
        </div>
        {/* Settings / Configuration */}
        <div className="mc-float-icon mc-icon-4">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1Z"></path></svg>
        </div>
      </div>

      {/* Movable V0 Assets */}
      <div className="mc-floating-assets mc-hidden-mobile">
        <div className="mc-floating-badge badge-1">
          <div className="mc-badge-dot" style={{ backgroundColor: 'var(--mc-accent)', color: 'var(--mc-accent)' }}></div>
          <span className="mc-badge-text">85+ AI Tools</span>
        </div>
        <div className="mc-floating-badge badge-2">
          <div className="mc-badge-dot" style={{ backgroundColor: 'var(--mc-primary)', color: 'var(--mc-primary)' }}></div>
          <span className="mc-badge-text">18 Days</span>
        </div>
        <div className="mc-floating-badge badge-3">
          <div className="mc-badge-dot" style={{ backgroundColor: '#0ea5e9', color: '#0ea5e9' }}></div>
          <span className="mc-badge-text">Certificate</span>
        </div>
      </div>

      <div className="mc-hero-grid">
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{ once: true, margin: "0px" }} style={{ zIndex: 10 }}>
          <motion.span variants={itemVariants} className="mc-hero-label">Comprehensive Roadmap</motion.span>
          <motion.h1 variants={itemVariants} className="mc-hero-title">
            Master <span className="mc-gradient-accent">85+</span>  <span className="mc-gradient-accent">AI Tools</span></motion.h1>
          <motion.h1 variants={itemVariants} className="mc-hero-title">& Stay Ahead in the AI Era.
          </motion.h1>
          <motion.p variants={itemVariants} className="mc-hero-subtitle">
            Our curriculum is designed to deliver only what truly matters—real skills used by top AI performers.
          </motion.p>
          {/* <div className="mc-hero-social-proof">
            <div className="mc-hero-avatars" style={{ display: 'flex' }}>
              <img src="https://lh3.googleusercontent.com/aida-public/AB6AXuAU_6d9bzwaJzQkywLHExdus0LbZqniUZPQ9g8hXsQYL6YBhy5w-TNdY5_NL2U2VuKxgDcqStBrstiNhxzLwo2vKPjJD56EK5WNWXD7kg5UIOqGNFbnmWm8xV4X5uBQVRXrlsJc3HTbRzOJU555FiwIlIn4a71iIbu_JMGBX9nPPFg_OANERUSn-DfI_GFJnmqNdH2fL-2z_GJS7gnR1oNTV09n80sB_7H77zwT75OGd6T_-3YqNNJHZAP-VM2RdKPxFwLM4mcuuuQ" alt="Student" className="mc-hero-avatar" />
              <img src="https://lh3.googleusercontent.com/aida-public/AB6AXuDzaiVtmY-x7OFY_CoRO58BpbvMGGjJ1_lQMNGmo7o9mkoauQwLShwMgdCPzitOcwsfBpkuswJ6YtoK-6cx1iCHDlxCRSQR-W2yC2B6x8PUHx2bSnw0gQD5JLF7qx0diwSx5NqJy_IraGo8UI7CASyuUVV43uZ8Qr-hrPo0mJCtgDcmnFu35uDzG6QqYxoBGgxcogcDzPPAl69O1MVOx38hrOG35QkaWoBbTzVMiK65qb3EqE8DWl3S7NScgTwXSgAv3zbUBFGvRfg" alt="Student" className="mc-hero-avatar" />
              <img src="https://lh3.googleusercontent.com/aida-public/AB6AXuCKfdrXQgb9KvnP9d9pqBT-2xonjjO8urw1rujNdQLWbUn_EIa4r_YRCG0MCLBNsTWICuGA6LC7gqXoGC131qnjoOCW6dL479HkWZ4XbUqmRjH2JNUdW7YjXC1Y9tJxf1YllYRNwZju6X0E_jnfx-u7SjdzNS3nFv5UrS1L_5Us3NiagsnsK0vZkODUEFJlbyepDr4D2drrUl7f4oD-Hea20K1XFBtjyQtg1zqbD9ooUww_XfLRbQVgUNZzuvtBSFFcoqjE4hUl2RE" alt="Student" className="mc-hero-avatar" />
            </div>
            <p className="mc-hero-proof-text">+1,200 alumni already enrolled</p>
          </div> */}
        </motion.div>
        <motion.div variants={popVariants} initial="hidden" whileInView="visible" viewport={{ once: true }} className="mc-hero-visual relative">
          <div style={{ position: 'absolute', top: '-2.5rem', right: '-2.5rem', width: '16rem', height: '16rem', backgroundColor: 'rgba(155, 135, 245, 0.4)', borderRadius: '9999px', filter: 'blur(60px)', zIndex: 0 }}></div>
          <div className="mc-hero-image-wrapper">
            <div className="mc-hero-bg-container">
              <img
                src="https://images.unsplash.com/photo-1677442136019-21780ecad995?auto=format&fit=crop&q=80&w=800"
                alt="AI Concept"
                className="mc-hero-image"
              />
              <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to top, rgba(3,3,3,0.8), transparent)' }}></div>
            </div>

            {/* Absolute positioning of the mentor image */}
            <img
              src={heroPerson}
              alt="Anshuman"
              className="mc-hero-person-absolute"
            />

            <div className="mc-glass-card mc-hero-card-overlay">
              <div>
                <p className="mc-hero-card-label">Admissions On</p>
                <p className="mc-hero-card-title">Sunday, April 05</p>
              </div>
              <div className="mc-hero-badge">First Come First Serve</div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default MasterclassHero;
